<template>
  <div id="app">
    <HomeHeader v-if="showHeader" @login="handleLogin" @enter-bar="handleEnterBar" />
    <keep-alive>
      <router-view />
    </keep-alive>
    <LoginDialog :visible="showLoginDialog" @close="handleCloseDialog" />
  </div>
</template>
<script>
import HomeHeader from '@/components/HomeHeader/HomeHeader.vue';
import LoginDialog from '@/components/LoginDialog/LoginDialog.vue';

// import { isPc, getQueryString } from '@/utils/index';

export default {
  name: 'app',
  components: {
    HomeHeader,
    LoginDialog,
  },
  data() {
    return {
      showLoginDialog: false,
    };
  },
  computed: {
    showHeader() {
      // 从当前路由和父路由中查找 showHeader
      const { matched } = this.$route;
      for (let i = matched.length - 1; i >= 0; i -= 1) {
        if (matched[i].meta?.showHeader !== undefined) {
          return matched[i].meta.showHeader;
        }
      }
      return false;
    },
  },
  created() {
    // 初始化用户信息（从 localStorage 读取）
    this.$store.commit('initUserInfo');
    
    // const tmpInviteCode = getQueryString('inviteCode');
    // if (tmpInviteCode) {
    //   this.$store.commit('setInviteCode', tmpInviteCode);
    // }
    // const tmpIsPc = isPc();
    // if (!tmpIsPc) {
    //   console.log(location.href);
    //   if (location.href.indexOf('phoneRegister') > -1) {
    //     this.$router.replace({
    //       path: '/phoneRegister',
    //     });
    //   } else {
    //     this.$router.replace({
    //       path: '/phoneHome',
    //     });
    //   }
    // }
  },
  methods: {
    handleLogin() {
      this.showLoginDialog = true;
    },
    handleCloseDialog() {
      this.showLoginDialog = false;
    },
    handleEnterBar() {
      const redirectUrl = `${window.location.origin}/bar-customer/index.html#/app/home`;
      window.location.href = redirectUrl;
    },
  },
};
</script>

<style lang="less">
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
}
body {
  background-color: #000;
  color: #000000;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400;
}

</style>
